export default __webpack_public_path__ + "static/media/gray-dash.67d893e0.svg";